import { Navigate } from "react-router-dom";

const PublicRoute = ({ children }) => {
  const isAuthenticated =
    localStorage.getItem("isAuthenticated") === "true";

  return isAuthenticated
    ? <Navigate to="/platform-overview-dashboard" replace />
    : children;
};

export default PublicRoute;
